define(['jquery', 'c21/internationalization'], function ($, internationalization) {
   "use strict";

   return function (jTooltip) {
      var jPropPhotos = jTooltip.find('.propPhotos'),
         jLeft = jPropPhotos.find('.slideImgBtnLeft'),
         jRight = jPropPhotos.find('.slideImgBtnRight'),
         jImg = jPropPhotos.find('img'),
         jLink = jPropPhotos.find('.photoLink'),
         sUrl = jLink.attr('href'),
         jAllPhotos = jTooltip.find('.allPhotos'),
         jTotalImages = jTooltip.find('.totalImagesText'),
         jPropImageUrl = jAllPhotos.find(".propImageURL"),
         aStrPhotos = [],
         iCurrentPhoto = 0,
         bLoading = false,
         imageLoading = new Image(),

         setPhotoIndexText = function (iPhoto) {
            var strText = [
               internationalization.getString('Photo'),
               (iPhoto + 1).toString(),
               internationalization.getString('of'),
               aStrPhotos.length.toString()
            ].join(' ');
            jTotalImages.text(strText);
         },

         setPhotoIndex = function (iNextPhoto) {
            if (bLoading) {
               return;
            }

            var image = new Image(),
               strNextPhoto = aStrPhotos[iNextPhoto];

            jImg.src = imageLoading.src;

            bLoading = true;
            image.onload = function () {
               iCurrentPhoto = iNextPhoto;
               jImg.attr('src', strNextPhoto);
               bLoading = false;
               jLink.attr('href', sUrl + '?g=' + iNextPhoto);
               setPhotoIndexText(iNextPhoto);
            };

            image.src = strNextPhoto;
         },

         initialize = function () {
            imageLoading.src = '/images/eco/mapping/snake-black-32x32.gif';

            jPropImageUrl.each(function (i, el) {
               var jProp = $(el),
                  strUrl = jProp.text();

               aStrPhotos.push(strUrl);
            });

            setPhotoIndex(0);

            jLeft.click(function () {
               var iNextPhoto = (iCurrentPhoto + aStrPhotos.length - 1) % aStrPhotos.length;
               setPhotoIndex(iNextPhoto);
            });

            jRight.click(function () {
               var iNextPhoto = (iCurrentPhoto + 1) % aStrPhotos.length;
               setPhotoIndex(iNextPhoto);
            });

            // Hide the left and right photo slideshow navigation buttons
            if (aStrPhotos.length <= 1) {
               jLeft.hide();
               jRight.hide();
            }
         };

      initialize();
   };
});
